import { RiveArt } from "@/components/rive/RiveArt";

/** The owl's head outline on its 200 grid (same shapes as public/nightowl-mark.svg and the Rive owl). */
export const OWL_HEAD = "M28 42 L80 62 C93.33 58.67 106.67 58.67 120 62 L172 42 L164 110 C164 152 136 178 100 178 C64 178 36 152 36 110 Z";

/**
 * The Night Owl mark, still. The eyes take the background's color (--owl-eyes, black on the night
 * sky, ink on light pages) so the owl looks out of whatever it sits on.
 */
export function BrandMark({ size = 28, className }: { size?: number; className?: string }) {
  return (
    <svg className={className} width={(size * 156) / 148} height={size} viewBox="22 36 156 148" aria-hidden="true" focusable="false">
      <path d={OWL_HEAD} fill="var(--brand-cyan, #059BA0)" stroke="var(--brand-cyan, #059BA0)" strokeWidth={10} strokeLinejoin="round" />
      <g fill="var(--owl-eyes, #000)">
        <circle cx="72" cy="106" r="28" />
        <circle cx="128" cy="106" r="28" />
        <path d="M92 140 L108 140 L100 154 Z" stroke="var(--owl-eyes, #000)" strokeWidth={4} strokeLinejoin="round" />
      </g>
      <circle cx="72" cy="106" r="11" fill="var(--brand-cyan, #059BA0)" />
      <circle cx="128" cy="106" r="11" fill="var(--brand-cyan, #059BA0)" />
    </svg>
  );
}

/**
 * The owl, alive: blinks and glances around, and on hover the string of lights along its brow
 * chases through colors. The still mark shows until the animation is ready (and stays for people who
 * prefer less motion).
 */
export function AnimatedBrandMark({ size = 28 }: { size?: number }) {
  // The artboard is 200 square around the owl's 156 x 148: draw it a little larger, with negative
  // margins, so the owl itself lands where the still mark would.
  const px = Math.round((size * 200) / 148);
  const pad = (px - size) / 2;
  return (
    <span style={{ display: "inline-grid", margin: `-${pad}px -${(px - (size * 156) / 148) / 2}px` }}>
      <RiveArt artboard="owl-mark" width={px} height={px} hoverFromParent fallback={<BrandMark size={size} />} />
    </span>
  );
}

/** Mark and name together, for the sidebar and sign-in pages. */
export function BrandLockup({ size = 28, animated = false }: { size?: number; animated?: boolean }) {
  return (
    <>
      {animated ? <AnimatedBrandMark size={size} /> : <BrandMark size={size} />}
      <span className="brand-name">Night Owl</span>
    </>
  );
}
